//====================================================
//  Function: Open detail
//====================================================
function componentOpenNote() {
  if ($('.js-open-note').length) {
    var noteModal = $('.js-modal[data-modal="partner-list"]')

    $('.js-open-note').click(function () {
      var inst = $(this)
      noteModal.addClass('is-open-detail')
      clearNoteForm()
      $('.js-note-input-id').val('new')
      return false
    })

    var noteId,
      noteTitle,
      notePhone,
      noteEmail,
      noteDescription,
      noteDate,
      notePlace,
      noteChecklist,
      noteCreated

    var noteInputTitle = $('.js-note-input-title'),
      noteInputPlace = $('.js-note-input-place'),
      noteInputPerson = $('.js-note-input-person'),
      noteInputPhone = $('.js-note-input-phone'),
      noteInputEmail = $('.js-note-input-email'),
      noteInputChecklist = $('.js-note-input-checklist'),
      noteDateCreated = $('.js-note-input-created'),
      noteInputId = $('.js-note-input-id'),
      noteInputDate = $('.js-note-input-date'),
      noteInputDescription = $('.js-note-input-description')

    $('.js-edit-note').click(function () {
      var inst = $(this)
      var noteItem = inst.closest('.js-note-item')

      noteId = noteItem.data('id')
      noteTitle = noteItem.find('.js-note-title').text()
      notePhone = noteItem.find('.js-note-phone').text()
      noteEmail = noteItem.find('.js-note-email').text()
      noteDescription = noteItem.find('.js-note-description').text()
      noteDate = noteItem.data('date')
      notePlace = noteItem.data('place')
      noteChecklist = noteItem.find('.js-note-checklist').text()
      noteCreated = noteItem.find('.js-note-created').text()

      if (noteItem.hasClass('is-open')) {
        noteItem.toggleClass('is-open')
        noteModal.toggleClass('is-open-detail')
      } else {
        noteModal.find('.js-note-item.' + 'is-open' + '').removeClass('is-open')
        noteItem.addClass('is-open')
        noteModal.addClass('is-open-detail')

        noteInputTitle.val(noteTitle)
        noteInputPlace.val(notePlace)
        noteInputPhone.val(notePhone)
        noteInputEmail.val(noteEmail)

        noteInputDate.val(noteDate)
        calendarDate.setDate(noteDate)

        noteInputDescription.val(noteDescription)
        noteInputChecklist.val(noteChecklist)
        noteDateCreated.text(noteCreated)
        noteInputId.val(noteId)

        autosize.update(textarea)
      }
      return false
    })

    $('.js-close-detail').click(function () {
      $('.js-modal[data-modal="partner-list"]').removeClass('is-open-detail')
      $('.js-note-item.is-open').removeClass('is-open')
    })

    function clearNoteForm() {
      $('.js-form-note').find('input, textarea').val('')
      autosize.update(textarea)
    }
  }
}
